<template>
    <v-container
      class="fill-height py-0 bglayer"
      fluid
      :style="`background: url(${background})`"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
          class="pa-0"
        >
          <v-card class="elevation-0 login--card pa-5 mx-auto" color="rgba(0, 0, 0, 0)">
            <v-card-text class="login--fieldbg pb-0">
              <ValidationObserver ref="observer">
                <v-form class="mt-2 mb-2">
                  <v-img
                    class="mb-11 mx-auto"
                    max-height="106"
                    max-width="90"
                    :src="logo"
                  ></v-img>
                  <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required">
                    <v-text-field
                      label="Email Address"
                      name="login"
                      type="text"
                      v-model="form.email"
                      dark
                      outlined
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    v-model="form.password"
                    dark
                    outlined
                    :error-messages="errors"
                    required
                    v-on:keyup.enter="submit"
                  ></v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="px-0 pt-0">
              <v-spacer></v-spacer>
              <v-btn x-large min-width="248" light color="primary" class="mb-4 mt-0" @click.prevent="submit" :loading="loading" tile depressed>Log In</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import logo from "@/assets/logo-o.png"
    import background from "@/assets/background.png"

    setInteractionMode('eager')

    extend('required', {
      ...required,
      message: '{_field_} can not be empty',
    })

    export default {
        props: {
        source: String,
        },
        data: () => ({
            form: {
                email: '',
                password: ''
            },
            loading: false,
            logo: logo,
            background: background
        }),
        components: {
          ValidationProvider,
          ValidationObserver,
        },
        methods: {
            ...mapActions({
              signIn: 'auth/signIn'
            }),
            async submit() {              
              let valid = await this.$refs.observer.validate()

              if(valid) {
                this.loading = true
                this.signIn(this.form).then(() => {
                    this.$router.replace({
                      name: 'Dashboard'
                    })
                }).catch(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  this.$store.commit('SET_SNACK', 'Login Failed! Please try again.')
                })
              }
            },
        }
    }
</script>

<style lang="sass">   
main
  &.v-content
    &.Home 
      background: #df2027

.transitionBG 
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 100%
  background: #000
  z-index: 9999999999
  
.login--card
  max-width: 420px
  background: #797979b5!important
  border-radius: 3px

.v-toolbar__title
  &.display-1
    &.text-uppercase
      &.font-weight-black
        &.sub--title 
          &.login--title
            font-size: 36px!important
            line-height: 1em!important
            letter-spacing: 0!important
            font-family: Pyxel!important
            margin-bottom: 15px!important

.title--toolbar 
  .v-toolbar__content 
    padding-left: 0
    padding-right: 0

.container
  &.bglayer
    &:before
      content: ""
      position: absolute
      width: 100%
      height: 100%
      background: rgb(37 37 37 / 78%)
      left: 0
      top: 0
</style>